<template>
  <div class="register-wrapper">
    <div class="title-type"><span>用户注册</span></div>
    <div class="title-wrapper">视觉训练档案</div>
    <div class="title-icon"><div class="icon"></div></div>
    <div class="success-text"><span>注册成功!</span></div>
    <div class="remind-text">
      <span>为了保障信息安全,请务必保管好您的身份信息和账号密码</span>
    </div>
    <!--
      <div class="confirm-btn-wrapper">
        <el-button @click="handleSuccessDialog" type="primary" class="confirm-btn"



          >确认</el-button



        >



      </div>
    -->
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component()
// 注意修改class名
export default class Register extends Vue {
  handleSuccessDialog() {
    console.log('完成')
    window.opener = null
    window.open('', '_self')
    window.close()
  }
}
</script>

<style lang="scss" scoped>
.register-wrapper {
  height: 100vh;

  width: 100%;

  background-color: #fff;

  padding: 30px 20px 20px 20px;

  display: flex;

  flex-direction: column;

  align-items: center;

  .title-wrapper {
    font-size: 2.5rem;

    width: 100%;

    padding: 20px 0 0 20px;

    color: #1582f0;

    font-weight: bold;

    text-align: center;
  }
  .title-type {
    width: 100%;
    text-align: center;
    padding: 5px 0 15px;
    font-size: 1.2rem;
    font-weight: 600;
    border-bottom: solid 2px #1582f0;
  }
  .title-icon {
    width: 100%;
    display: flex;
    justify-content: center;
    .icon {
      margin: 30px;
      position: relative;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      border: solid 4px #38c48b;
      // background-color: red;
    }
    .icon:before {
      position: absolute;
      content: '';
      width: 16px;
      height: 32px;
      transform: rotate(45deg);
      border-right: 4px solid #38c48b;
      border-bottom: 4px solid #38c48b;
      top: 17px;
      left: 44%;
    }
  }
  .remind-text {
    font-size: 1.2rem;
    font-weight: 00;
    letter-spacing: 1px;
    margin: 10px;
    line-height: 1.3;
    text-align: center;
    color: #bec0c2;
  }
  .success-text {
    font-size: 1.2rem;
    font-weight: 600;
    margin: 10px;
  }
  .confirm-btn-wrapper {
    bottom: 40px;
    width: 100%;
    position: absolute;
    bottom: 60px;
    text-align: center;
    .confirm-btn {
      width: 50%;
      background-color: #1582f0;
    }
  }
}
</style>
